import { createClient } from 'https://esm.sh/@supabase/supabase-js@2.76.1';
const menu=document.querySelector('[data-fp-account-menu]');
if(menu){
  const locale=menu.dataset.locale==='hy'?'hy':'ru';
  const client=createClient('https://lvozomkmnlyadntzwswm.supabase.co','sb_publishable_8H-O48sDfkUcICt_1lrkkQ_D0kP-Vfy',{auth:{persistSession:true,autoRefreshToken:true,detectSessionInUrl:true}});
  const nameTop=menu.querySelector('[data-fp-account-name]');
  const nameBox=menu.querySelector('[data-fp-account-menu-name]');
  const profile=menu.querySelector('[data-fp-account-profile]');
  const orders=menu.querySelector('[data-fp-account-orders]');
  const pets=menu.querySelector('[data-fp-account-pets]');
  const logout=menu.querySelector('[data-fp-account-logout]');
  const orderCount=menu.querySelector('[data-fp-order-count]');
  const petCount=menu.querySelector('[data-fp-pet-count]');
  const base=locale==='hy'?'https://4pets.am/pages/personal-account':'https://4pets.am/ru/pages/personal-account';
  async function paint(){
    const {data:{session}}=await client.auth.getSession();
    if(!session?.user)return;
    const [{data:p},{count:pc},{count:oc}]=await Promise.all([
      client.from('profiles').select('first_name').eq('id',session.user.id).single(),
      client.from('pets').select('id',{count:'exact',head:true}),
      client.from('shopify_orders').select('id',{count:'exact',head:true})
    ]);
    const first=(p?.first_name||'').trim()||'4PETS';
    nameTop.textContent=first;nameTop.hidden=false;
    nameBox.textContent=first;nameBox.hidden=false;
    profile.href=base;profile.textContent=locale==='hy'?'Իմ պրոֆիլը':'Мой профиль';
    orders.href=base+'?tab=orders';orders.hidden=false;
    pets.href=base+'?tab=pets';pets.hidden=false;
    logout.hidden=false;
    if(Number.isFinite(oc)&&oc>0)orderCount.textContent=String(oc);
    if(Number.isFinite(pc)&&pc>0)petCount.textContent=String(pc);
  }
  logout?.addEventListener('click',async()=>{await client.auth.signOut();location.href=base});
  paint();
}